import {
    Listbox,
    ListboxButton,
    ListboxOption,
    ListboxOptions,
} from "@headlessui/react";
import { useField } from "formik";
import { FaCheckCircle } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import cn from "../../../lib/cn";

const LabeledFormikSelect = ({
    name,
    label,
    options,
    required,
    disabled,
    wrapperClassName,
    onChange = () => {},
}) => {
    const [field, meta, helpers] = useField(name);
    const { setValue } = helpers;
    const selectedOption = options.find((opt) => opt.value === field.value);

    return (
        <div className={cn("mb-2 2xl:mb-3.2", wrapperClassName)}>
            <Listbox
                value={selectedOption || ""}
                onChange={(val) => {
                    setValue(val.value);
                    onChange(val.value);
                }}
                disabled={disabled}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="relative">
                    <ListboxButton
                        onBlur={() => {
                            helpers.setTouched(true);
                        }}
                        onFocus={() => helpers.setTouched(true)}
                        className={`relative w-full rounded-sm focus:outline-none  focus:ring-2 focus:ring-blue-500 text-btn-s  px-px py-px border  font-vietnam flex justify-between  ${
                            meta.touched && meta.error
                                ? "border-red border border-solid "
                                : "bg-custom-gradient border-transparent"
                        }`}
                    >
                        {label && (
                            <label
                                htmlFor={field.name}
                                className={cn(
                                    "text-xs lg:text-sm truncate font-urbanist absolute left-1.8 -top-1 bg-white px-0.8 flex items-center gap-0.5"
                                    // labelClass
                                )}
                            >
                                {label}{" "}
                                {required && (
                                    <span className="text-red">*</span>
                                )}
                            </label>
                        )}
                        <span
                            className="block truncate bg-white rounded-sm px-2 py-1.5 lg:py-[11.5px] w-full text-left text-primary text-xs xs:text-sm sm:text-base xl:text-base 2xl:text-xl
                    disabled:bg-gray-100 font-light "
                        >
                            {selectedOption
                                ? selectedOption.label
                                : "Select..."}{" "}
                        </span>
                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-0.5">
                            <IoIosArrowDown className="h-2 w-2 text-primary" />
                        </span>
                    </ListboxButton>
                    <ListboxOptions className="absolute z-10 mt-1 w-full max-h-60 overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        {options.map((option) => (
                            <ListboxOption
                                key={option.value}
                                value={option}
                                className={({ selected }) =>
                                    `relative cursor-pointer select-none py-0.8 pl-10 pr-4 ${
                                        selected
                                            ? "bg-blue-100 text-blue-50"
                                            : "text-primary"
                                    }`
                                }
                            >
                                {({ selected }) => (
                                    <div className="flex items-center gap-1 relative">
                                        {selected && (
                                            <span className=" absolute -left-2 inset-y-0 flex items-center">
                                                <FaCheckCircle />
                                            </span>
                                        )}
                                        <span
                                            className={`text-xs  ${
                                                selected
                                                    ? "font-medium"
                                                    : "font-normal"
                                            }`}
                                        >
                                            {option.label}
                                        </span>
                                    </div>
                                )}
                            </ListboxOption>
                        ))}
                    </ListboxOptions>
                </div>
            </Listbox>
            {meta.touched && meta.error && (
                <span className="text-red text-sm xl:text-base flex items-center flex-wrap gap-0.5">
                    {meta.error}*
                </span>
            )}
        </div>
    );
};

export default LabeledFormikSelect;
